import 'dom4';
import {waitForVideo, waitForImage, portrait} from './shared.js';
import * as intro from './intro.js';
import {setupChapters} from './chapters.js';
import {setupTransitioner} from './transitioner.js';
import './nav.js';
import './scrollguide.js';
import './tracking.js';

/**
 * Utility to preload an image
 * @param {String} src path
 * @param {Number} width (optional)
 * @param {Number} height (optional)
 * @return {Image} image
 */
function preloadImage(src, width, height) {
  const image = new Image(width, height);
  image.src = src;
  return image;
}

const videos = Array.from(document.querySelectorAll('video')).filter(video => !portrait.matches || !video.classList.contains('only-desktop'));
const images = [
  ...new Set([
    ...document.querySelectorAll('#fixed-container img'),
    ...videos.map(video => preloadImage(video.poster)),
  ].filter(img => img.nodeName === 'IMG')), // Edge bug counts SVG <image> elements in query: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/7163109/
];

// total number of assets (images + videos) to preload
const assetTotal = images.length + videos.length;
const loadTimeout = Infinity;
let assetsPreloadedCount = 0;
let elapsed = 0;

/**
 * Called when an asset (image or video) has preloaded (as defined for that asset).
 * Tracks of the total loaded assets and notifies the intro of the current total.
 */
function assetPreloaded() {
  ++assetsPreloadedCount;
  intro.assetPreloaded(assetsPreloadedCount / assetTotal, elapsed);
}

const videosPromise = Promise.all([
  ...videos.map(video => waitForVideo(video).then(() => assetPreloaded())),
]);

const imagesPromise = Promise.all(images.map(image => waitForImage(image).then(() => assetPreloaded())));

videosPromise.then(() => console.log('all videos loaded'));
imagesPromise.then(() => console.log('all images loaded'));

const assetLoadingPromise = Promise.all([videosPromise, imagesPromise]);

assetLoadingPromise.then(() => console.log('all images and videos loaded'));

// setupPromise waits for assets to preload, then calls initialization code and resolves
const setupPromise = assetLoadingPromise.then(() => setupChapters()).then(() => setupTransitioner());

setupPromise.then(() => console.log('assets loaded, chapters initialized, transitioner initialized')).then(() => console.log('starting intro'));

// pass the setupPromise to the intro, which waits until setup is complete before completing
intro.startIntro(setupPromise);
